// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-divider--horizontal[data-v-066c768a] {\n  margin: 5px 0 !important;\n}", ""]);
// Exports
module.exports = exports;
